<template>
	<NewTeamMemberRowLayout class="new-team-member-row-header">
		<template v-slot:email>
			<label class="new-team-member-row-header__column-label">
				{{ translate( "emailColumnHeader" ) }}
			</label>
		</template>
		<template v-slot:status>
			<label class="new-team-member-row-header__column-label">
				{{ translate( "statusColumnHeader" ) }}
			</label>
		</template>
		<template v-slot:role>
			<label class="new-team-member-row-header__column-label">
				{{ translate( "roleColumnHeader" ) }}
			</label>
		</template>
	</NewTeamMemberRowLayout>
</template>

<script>
import {
	TranslateMixin
} from "@teaming/common-ui";

import NewTeamMemberRowLayout from "./NewTeamMemberRowLayout.vue";

export default {
	name: "NewTeamMemberRowHeader",
	teamingPackage: "common-team",
	mixins: [ TranslateMixin, ],
	components: {
		NewTeamMemberRowLayout,
	},
};
</script>

<style lang="scss" scoped>
$columnLabelColor: $color1-500;

.new-team-member-row-header {
	height: 1.875rem;
}

.new-team-member-row-header__column-label {
	@include font-and-line-for(0);
	font-weight: 600;
	color: $columnLabelColor;
}
</style>
